import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import { Panel, PanelLayout } from 'components/PanelLayout';
import { EditPanel } from './editPanel/EditPanel';
import { ViewPanel } from './viewPanel/ViewPanel';
import Button from 'components/Button/Button';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { useParams } from 'react-router-dom';
import {
  getClientOrderHoursThunk,
  getClientSpecialOrderHoursThunk,
} from 'companyLocations/redux/reducers/orderHours/thunk';
import { ContextParams } from 'types/ContextParams.interface';
import { SimplePanelLayout } from 'components/PanelLayout/SimplePanelLayout';
import styles from './OrderHoursPanel.module.scss';

export const OrderHoursPanel = () => {
  const dispatch = useAppDispatch();
  const { contextId: companyId, locationId } = useParams<ContextParams>();
  const [isEditModeActive, setIsEditModeActive] = useState(false);
  const { loading } = useAppSelector((state) => state.location.orderHours);

  useEffect(() => {
    dispatch(getClientOrderHoursThunk({ companyId, locationId }));
  }, [companyId, dispatch, locationId]);

  useEffect(() => {
    dispatch(getClientSpecialOrderHoursThunk({ locationId, companyId }));
  }, [companyId, dispatch, locationId]);

  const closeForm = () => {
    setIsEditModeActive(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <SimplePanelLayout customStyle={styles.simplePanelLayout}>
          <PanelLayout>
            <Panel
              title='Ordering Hours'
              headerControls={
                isEditModeActive ? undefined : (
                  <Button
                    variant='secondary'
                    label='Edit'
                    size='large'
                    loading={loading}
                    onClick={() => setIsEditModeActive(true)}
                  />
                )
              }
            >
              {isEditModeActive ? <EditPanel closeForm={closeForm} /> : <ViewPanel />}
            </Panel>
          </PanelLayout>
        </SimplePanelLayout>
      )}
    </>
  );
};
